/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIContactAddress } from './APIContactAddress';
import {
    APIContactAddressFromJSON,
    APIContactAddressFromJSONTyped,
    APIContactAddressToJSON,
} from './APIContactAddress';

/**
 * 
 * @export
 * @interface APIContactSearchResult
 */
export interface APIContactSearchResult {
    /**
     * 
     * @type {string}
     * @memberof APIContactSearchResult
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof APIContactSearchResult
     */
    score: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIContactSearchResult
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactSearchResult
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactSearchResult
     */
    mobile?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactSearchResult
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactSearchResult
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactSearchResult
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactSearchResult
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactSearchResult
     */
    comment?: string;
    /**
     * 
     * @type {number}
     * @memberof APIContactSearchResult
     */
    preferredContactMethod?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIContactSearchResult
     */
    preferredContactMethodDisplay?: string;
    /**
     * 
     * @type {Array<APIContactAddress>}
     * @memberof APIContactSearchResult
     */
    addresses?: Array<APIContactAddress>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIContactSearchResult
     */
    addressCities?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIContactSearchResult
     */
    addressCountries?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APIContactSearchResult
     */
    rootAccountId?: string | null;
}

/**
 * Check if a given object implements the APIContactSearchResult interface.
 */
export function instanceOfAPIContactSearchResult(value: object): value is APIContactSearchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function APIContactSearchResultFromJSON(json: any): APIContactSearchResult {
    return APIContactSearchResultFromJSONTyped(json, false);
}

export function APIContactSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIContactSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'score': json['score'],
        'email': json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'mobile': json['mobile'] == null ? undefined : json['mobile'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'fullName': json['full_name'] == null ? undefined : json['full_name'],
        'language': json['language'] == null ? undefined : json['language'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'preferredContactMethod': json['preferred_contact_method'] == null ? undefined : json['preferred_contact_method'],
        'preferredContactMethodDisplay': json['preferred_contact_method_display'] == null ? undefined : json['preferred_contact_method_display'],
        'addresses': json['addresses'] == null ? undefined : ((json['addresses'] as Array<any>).map(APIContactAddressFromJSON)),
        'addressCities': json['address_cities'] == null ? undefined : json['address_cities'],
        'addressCountries': json['address_countries'] == null ? undefined : json['address_countries'],
        'rootAccountId': json['root_account_id'] == null ? undefined : json['root_account_id'],
    };
}

export function APIContactSearchResultToJSON(value?: APIContactSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'score': value['score'],
        'email': value['email'],
        'phone': value['phone'],
        'mobile': value['mobile'],
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'full_name': value['fullName'],
        'language': value['language'],
        'comment': value['comment'],
        'preferred_contact_method': value['preferredContactMethod'],
        'preferred_contact_method_display': value['preferredContactMethodDisplay'],
        'addresses': value['addresses'] == null ? undefined : ((value['addresses'] as Array<any>).map(APIContactAddressToJSON)),
        'address_cities': value['addressCities'],
        'address_countries': value['addressCountries'],
        'root_account_id': value['rootAccountId'],
    };
}

